<template>
  <div :data-test="dataTest">
    <ComplianceStatusLabel :status="status" xs />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import ComplianceStatusLabel from '@/components/compliances/ComplianceStatusLabel.vue'
import { RecruiterComplianceStatus, VerifiedWorkerComplianceStatus } from '@/gql/graphql'
import { user } from '@/composables/useUser'

const props = defineProps<{
  dataTest: string
  completed: boolean | null | undefined
  status: VerifiedWorkerComplianceStatus | RecruiterComplianceStatus | null
}>()

// The worker and staffing agency enums share their values.
const STATUS_BY_VALUE: Record<string, VerifiedWorkerComplianceStatus> = {
  [VerifiedWorkerComplianceStatus.Cleared]: VerifiedWorkerComplianceStatus.Cleared,
  [VerifiedWorkerComplianceStatus.ChangesRequested]: VerifiedWorkerComplianceStatus.ChangesRequested,
  [VerifiedWorkerComplianceStatus.ReadyToReview]: VerifiedWorkerComplianceStatus.ReadyToReview,
}

const status = computed(() => {
  if (!user.value.hasPermission('view-compliance-tracker')) {
    return VerifiedWorkerComplianceStatus.Incomplete
  }

  if (!user.value.hasPermission('manage-compliance-tracker')) {
    return props.completed
      ? VerifiedWorkerComplianceStatus.Cleared
      : VerifiedWorkerComplianceStatus.Incomplete
  }

  return (props.status && STATUS_BY_VALUE[props.status]) || VerifiedWorkerComplianceStatus.Incomplete
})
</script>
